@if (loading()) {
  <mat-spinner [diameter]="size() === 'small' ? 16 : 20"></mat-spinner>
} @else if (size() === 'normal') {
  <button class="delete-btn" [matTooltip]="'button.delete' | trans" (click)="onDelete()">
    <mat-icon>delete</mat-icon>
  </button>
} @else if (size() === 'small') {
  <button class="delete-btn delete-btn-small" [matTooltip]="'button.delete' | trans" (click)="onDelete()">
    <mat-icon>delete</mat-icon>
  </button>
}
